import { createContext } from "react";

export const NotifyContext = createContext(null);